if (!customElements.get('tandoori-catalog-sort')) {
  customElements.define('tandoori-catalog-sort', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      for (const link of this.querySelectorAll('[data-sort]')) {
        // Retain active filters, but always start a new ordering at page one.
        const update = () => {
          const url = new URL(location.href);
          url.searchParams.set('sort_by', link.dataset.sort);
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          link.href = url.href;
        };
        update();
        link.addEventListener('click', update);
        link.addEventListener('pointerdown', update);
      }
    }
  });
}
